import { useMemo, useState } from 'react';
import { formatUserEmail } from '../../utils/formatUserEmail';
import { User } from './types';

export const useUserSearch = (users: User[] | undefined) => {
  const [searchTerm, setSearchTerm] = useState('');

  const filteredUsers = useMemo(() => {
    if (!users) {
      return [];
    }

    // Remove duplicates by userId
    const uniqueUsers = users.reduce((accumulator: User[], user) => {
      const isDuplicate = accumulator.some(
        (existingUser) => existingUser.userId === user.userId
      );
      if (!isDuplicate) {
        accumulator.push(user);
      }
      return accumulator;
    }, []);

    if (!searchTerm) {
      return uniqueUsers;
    }

    const lowerSearchTerm = searchTerm.toLowerCase();
    return uniqueUsers.filter((user) => {
      const emailMatches = user.userEmail
        .toLowerCase()
        .includes(lowerSearchTerm);
      const formattedName = formatUserEmail(user.userEmail).toLowerCase();
      const nameMatches = formattedName.includes(lowerSearchTerm);
      return emailMatches || nameMatches;
    });
  }, [users, searchTerm]);

  return {
    filteredUsers,
    searchTerm,
    setSearchTerm,
  };
};
